import { useEffect, useRef, useState } from "react";
import Button from "./Button";
import Heading from "./Heading";
import TagHeading from "./TagHeading";

const methodologyData = [
  {
    id: "one1",
    title: "Discovery & Alignment",
    points: [
      "Deep dive into vision, culture, leadership expectations",
      "Stakeholder conversations with CXO/Board",
      "Creation of Leadership Success Profile (LSP)",
      "Definition of critical leadership traits"
    ],
    img: "/img/assets/home/discovery-and-alignment.webp",
  },
  {
    id: "two1",
    title: "Market Intelligence & Talent Mapping",
    points: [
      "Industry and competitor scan",
      "Mapping active & passive leadership talent",
      "Compensation & movement trend analysis",
      "Identification of niche leadership pools"
    ],
    img: "/img/assets/home/market-intelligence-and-talent-mapping.webp",
  },
  {
    id: "three1",
    title: "Confidential Outreach & Engagement",
    points: [
      "High-touch, relationship-based outreach",
      "Discreet conversations ensuring trust",
      "Position pitching based on value & purpose",
      "Engagement of global and India-specific networks"
    ],
    img: "/img/assets/home/confidential-outreach-&-engagement.webp",
  },
  {
    id: "four1",
    title: "Leadership Evaluation & Assessment",
    points: [
      "Behavioural Event Interviews (BEI)",
      "Leadership Personality (Psychometric profiling) & Strength Assessment",
      "Leadership Reactive and Proactive tendencies",
      "Cultural Fit Index",
      "Cognitive & Analytical Assessments",
      "Motivation & Value Alignment Diagnostics",
      "360° Leadership Feedback & External Referencing",
      "Background, Reputation & Compliance Checks"
    ],
    img: "/img/assets/home/leadership-evaluation-assessment.webp",
  },
  {
    id: "five1",
    title: "Recommendation & Selection Advisory",
    points: [
      "Final shortlist with leadership capability narratives",
      "Risk & Potential Analysis",
      "Culture Fit Score",
      "Detailed Candidate Evaluation Report",
      "Offer negotiation & closing support"
    ],
    img: "/img/assets/home/discovery-and-alignment.webp",
  },
  {
    id: "six1",
    title: "Onboarding & Integration Support",
    points: [
      "30-60-90 Day Leadership Assimilation Plan",
      "Stakeholder alignment sessions",
      "First 100-days support coaching",
      "Pulse check-ins to ensure smooth transition"
    ],
    img: "/img/assets/home/onboarding-and-integration-support.webp",
  },
];

export default function StickyScroll() {
  const [active, setActive] = useState("one1");
  const sectionRefsTwo = useRef({});

  useEffect(() => {
    // Disable observer on mobile
    // if (window.innerWidth < 1024) return;

    // const observer = new IntersectionObserver(
    //   (entries) => {
    //     entries.forEach((entry) => {
    //       if (entry.isIntersecting) {
    //         setActive(entry.target.id);
    //       }
    //     });
    //   },
    //   { threshold: 0.6 }
    // );

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            setActive(entry.target.id);
          }
        });
      },
      {
        threshold: 0.6,
        rootMargin: "-220px 0px -20% 0px"
      }
    );

    Object.values(sectionRefsTwo.current).forEach((section) => {
      if (section) observer.observe(section);
    });

    return () => observer.disconnect();
  }, []);

  const scrollToSection = (id) => {
    sectionRefsTwo.current[id]?.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <div className="bg-white py-24">
      <div className="mx-auto w-full 2xl:w-[80%] xl:w-11/12 px-4">

        {/* HEADER */}
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 pb-6 mb-16 lg:sticky top-20 bg-white z-10">
          <div>
            <TagHeading className="textactive" text="The Methodology" />
            <Heading className="textblack" text="Our Executive Search Methodology" />
            <p className="text-xl font-semibold textblack mt-5">A Six-Step, Research-Driven, Holistic Process</p>
          </div>
          <div className="flex flex-col justify-center">
            <p className="textblack text-lg mb-6">Our executive search methodology is a six-step, research-driven process focused on identifying leaders who deliver sustained impact. We go beyond credentials to assess capability, culture fit, and future potential.</p>
            {/* <div className="flex justify-center md:justify-start items-center md:items-center gap-4 md:w-64 w-full">
              <Button text="Explore More" />
            </div> */}
          </div>
        </div>

        {/* DESKTOP VIEW */}
        <div className="hidden lg:flex gap-16 items-start">

          {/* LEFT TABS */}
          <div className="sticky top-80 w-1/2 flex flex-col">
            {methodologyData.map((tab) => (
              <div
                key={tab.id}
                onClick={() => scrollToSection(tab.id)}
                className={`cursor-pointer px-5 pb-8 last:pb-0 border-l-4 transition-all duration-300
                  ${active === tab.id
                    ? "border-[#9B2635] textblack"
                    : "border-[#9B2635]/40 textgray"
                  }`}
              >
                <h1 className="md:text-xl text-lg font-semibold">{tab.title}</h1>
                {active === tab.id && (
                  <ul className="mt-4 space-y-2 list-disc ml-8 textblack text-sm">
                    {tab.points.map((point, index) => (
                      <li key={index}>{point}</li>
                    ))}
                  </ul>
                )}
              </div>
            ))}
          </div>

          {/* RIGHT IMAGES */}
          <div className="flex-1">
            {methodologyData.map((tab) => (
              // <section
              //   key={tab.id}
              //   id={tab.id}
              //   ref={(el) => (sectionRefsTwo.current[tab.id] = el)}
              //   className="min-h-[60vh] flex items-center mb-32"
              // >
              <section
                key={tab.id}
                id={tab.id}
                ref={(el) => (sectionRefsTwo.current[tab.id] = el)}
                className="min-h-[53vh] flex items-center mb-32 scroll-mt-[280px]"
              >

                <img
                  src={tab.img}
                  alt={tab.title}
                  className="w-full rounded-2xl"
                />
              </section>
            ))}
          </div>
        </div>

        {/* MOBILE VIEW */}
        <div className="lg:hidden space-y-20">
          {methodologyData.map((tab) => (
            <div key={tab.id} className="space-y-6">
              <h2 className="text-xl font-semibold textblack">{tab.title}</h2>
              <ul className="list-disc ml-8 space-y-2 textblack">
                {tab.points.map((point, index) => (
                  <li key={index}>{point}</li>
                ))}
              </ul>
              <img src={tab.img} alt={tab.title} className="w-full rounded-2xl shadow-lg" loading="lazy" />
            </div>
          ))}
        </div>

      </div>
    </div>
  );
}
